import { render, staticRenderFns } from "./BwfComponentCore.vue?vue&type=template&id=a6b037d0&scoped=true&"
import script from "./BwfComponentCore.vue?vue&type=script&lang=js&"
export * from "./BwfComponentCore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b037d0",
  null
  
)

export default component.exports